export default {
  getFileType(fileExtension) {
    const formattedFileExtension = fileExtension.replace(/^[.\s]+|[.\s]+$/g, "");

    const imageTypes = ['jpeg','jpg','png','gif','ico','webp','svg','apng','avif','bmp','tiff'];
    const documentTypes = ['pdf','doc','docx','html','xls','xlsx','ppt','pptx','zip','txt','odt'];

    const isImage = imageTypes.includes(formattedFileExtension);
    const isDocument = documentTypes.includes(formattedFileExtension);
    return isImage ? 'image' : (isDocument ? 'document' : '');
  }
}